// Generated with util/create-component.js
import { alpha, styled } from "@mui/material";
import EditorToolbar from "./EditorToolbar";
import MuiFormatBoldIcon from "@mui/icons-material/FormatBold";
import MuiFormatItalicIcon from "@mui/icons-material/FormatItalic";
import MuiFormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import MuiStrikethroughSIcon from "@mui/icons-material/StrikethroughS";
import MuiHighlightIcon from "@mui/icons-material/Highlight";
import MuiFormatColorTextIcon from "@mui/icons-material/FormatColorText";
import MuiFormatSizeIcon from "@mui/icons-material/FormatSize";
import MuiFormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import MuiFormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import MuiLinkIcon from "@mui/icons-material/Link";
import MuiImageIcon from "@mui/icons-material/Image";
import MuiCodeIcon from "@mui/icons-material/Code";
import MuiIntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";

export const StyledEditorToolbar = styled(EditorToolbar)(({ theme }) => {
    return {
        ".root": {
            padding: "0px 0px 0px 0px",
        },
        ".toolbar": {
            borderRadius: "7px 7px 0 0",
            backgroundColor: theme.palette.background.paper,
        },
        ".videoFrame": {
            width: "20%",
            height: "20%",
            position: "relative",
        },
        ".video": {
            width: "100%",
            height: "100%",
        },
        ".videoInput": {
            padding: "0 0% 0 0%",
            maxWidth: "300px",
            minWidth: "20%",
            marginTop: "5px",
            boxSizing: "border-box",
        },
    };
});

export const FormatBoldIcon = styled(MuiFormatBoldIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});
export const FormatItalicIcon = styled(MuiFormatItalicIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});

export const FormatUnderlinedIcon = styled(MuiFormatUnderlinedIcon)(
    ({ theme }) => {
        return {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.common.black
                    : alpha(theme.palette.common.white, 0.6),
        };
    }
);
export const StrikethroughSIcon = styled(MuiStrikethroughSIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});

export const HighlightIcon = styled(MuiHighlightIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});

export const FormatColorTextIcon = styled(MuiFormatColorTextIcon)(
    ({ theme }) => {
        return {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.common.black
                    : alpha(theme.palette.common.white, 0.6),
        };
    }
);

export const FormatSizeIcon = styled(MuiFormatSizeIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});

export const FormatListBulletedIcon = styled(MuiFormatListBulletedIcon)(
    ({ theme }) => {
        return {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.common.black
                    : alpha(theme.palette.common.white, 0.6),
        };
    }
);

export const FormatListNumberedIcon = styled(MuiFormatListNumberedIcon)(
    ({ theme }) => {
        return {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.common.black
                    : alpha(theme.palette.common.white, 0.6),
        };
    }
);

export const LinkIcon = styled(MuiLinkIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});
export const ImageIcon = styled(MuiImageIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});

export const CodeIcon = styled(MuiCodeIcon)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});

export const IntegrationInstructionsIcon = styled(
    MuiIntegrationInstructionsIcon
)(({ theme }) => {
    return {
        color:
            theme.palette.mode === "light"
                ? theme.palette.common.black
                : alpha(theme.palette.common.white, 0.6),
    };
});
